@import '../../utils/global.module.less';

.newDealButton {
    height: 45px;
    width: 100px;
}
